import {
  equals,
  isEmpty,
  isNil,
  always,
  has,
  cond,
  not,
  gte,
  gt,
  lt,
  lte,
  T,
  propEq,
  filter,
  F,
  head,
  split,
  includes,
  length,
  toLower,
  pathOr,
  toString,
  map,
  startsWith,
  flatten
} from 'ramda';
import { doNothing } from 'src/features/core/ChatEngine/Formatters/formatters';
import { YES_UPPERCASE_Y } from 'src/services/constants';
import { isEmptyOrNil, isNotEmpty } from 'src/utilities/hasValue';
import { unFormatCurrencyFn } from './formatCurrency';
import { getMonthsFromDate } from './date';

const not_equals = (a: any, b: any) => {
  return not(equals(a, b));
};

export const FORMATTER_CONDITIONAL_FUNCTIONS = [
  'isEmpty',
  'isNotEmpty',
  'isNil',
]

export const hasConsentYes = (consents: any) => {
  return isNotEmpty(filter(propEq('value', YES_UPPERCASE_Y))(consents))
}

export const hasNoConsentsYes = (consents: any) => {
  return isEmpty(filter(propEq('value', YES_UPPERCASE_Y))(consents))
}

const notContainsData = (a: any, b: string) => {
  const list = split(',', a)
  return not(includes(b, list))
}

const notContainsWithSeparator = (seperator: string = ',') => (a: string, b: string[]) => {
  const list = split(seperator, a)
  const result = isEmpty(filter((item:any) => includes(item, list), b ))
  return result
}

const containsData = (value: any, list: any) => {
  return  includes(toLower(value), map(toLower, flatten([list])))
}
export const includesData = (value: any, list: any=[]) => {
  return includes(value, list)
}

export const notIncludesData = (value: any, list: any=[]) => {
  return not(includes(value, list))
}

const hasSubStringCountGt = (text: string, count: string) => {
  const list = isNotEmpty(text) ? split(',', text) : []
  const result = gt(Number(count), 0) && not(equals(Number(count), length(list)))
  return result;
}

const checkRuleContext = (rule:any,answer:string) => {
  const ruleFlagger: any = pathOr(
    doNothing,
    ['ruleFlagger'],
    rule
  );
  const result = equals(toString(ruleFlagger()), toString(answer));
  return result;
}

const amountCompare = (comparitorFn: any) => (a: string, b: string) => {
  const result = comparitorFn(Number(unFormatCurrencyFn(a)), Number(unFormatCurrencyFn(b)))
  return result;
}

const termsInMonthgt = (submittedDate: string, maturityDate: string,currentTerms:string) => {
  const months =getMonthsFromDate(submittedDate,maturityDate)
  return gt(Number(currentTerms),Number(months))
}



const regexMatch = (matchString: string, regexPattern: string) => {
  const regex = new RegExp(regexPattern);
  return regex.test(matchString);
}

const regexNotMatch = (matchString: string, regexPattern:string) => {
    return not(regexMatch(matchString, regexPattern))
};


export const conditionalFuncs = (ctype: string) => {
  return cond([
    [
      equals('equals'),
      () => equals
    ],
    [
      equals('not_equals'),
      () => not_equals
    ],
    [
      equals('isEmpty'),
      () => isEmptyOrNil
    ],
    [
      equals('isNotEmpty'),
      () => isNotEmpty
    ],
    [
      equals('has'),
      () => has
    ],
    [
      equals('isNil'),
      () => isNil
    ],
    [
      equals('gt'),
      () => gt
    ],
    [
      equals('lt'),
      () => lt
    ],
    [
      equals('lte'),
      () => lte
    ],
    [
      equals('gte'),
      () => gte
    ],
    [
      equals('not_contains_substring'),
      () => notContainsData
    ],
    [
      equals('not_contains_with_separator'),
      () => notContainsWithSeparator(',')
    ],
    [
      equals('not_contains_with_pipe_separator'),
      () => notContainsWithSeparator('|')
    ],
    [
      equals('hasConsentYes'),
      always(hasConsentYes)
    ],
    [
      equals('hasNoConsentsYes'),
      always(hasNoConsentsYes)
    ],
    [
      equals('head'),
      () => head
    ],
    [
      equals('has_substring_count_gt'),
      always(hasSubStringCountGt)
    ],
    [
      equals('includes'),
      () => includesData
    ],
    [
      equals('not_includes'),
      ()=> notIncludesData
    ],
    [
      // Non case sensitive validation
      equals('contains'),
      ()=> containsData
    ],
    [
      // Non case sensitive validation
      equals('not_contains'),
      () => (value: any, items: any[]) => not(containsData(value, items))
    ],
    [
      equals('rule_context'),
      ()=> checkRuleContext
    ],
    [
      equals('startsWith'),
      always((start: any, value: any) => isNotEmpty(start) && startsWith(start, value))
    ],
    [
      equals('notStartsWith'),
      always((start: any, value: any) => isNotEmpty(start) && not(startsWith(start, value)))
    ],
    [
      equals('regex_match'),
      () => regexMatch
    ],
    [
      equals('regex_not_match'),
      () => regexNotMatch
    ],
    [
      equals('amount_gte'),
      () => amountCompare(gte)
    ],
    [
      equals('amount_lte'),
      () => amountCompare(lte)
    ],
    [
      equals('amount_gt'),
      () => amountCompare(gt)
    ],
    [
      equals('amount_lt'),
      () => amountCompare(lt)
    ],
    [
      equals('amount_equals'),
      () => amountCompare(equals)
    ],
    [
      equals('amount_not_equals'),
      () => amountCompare(not_equals)
    ],
    [
      equals('terms_in_month_gt'),
      () => termsInMonthgt
    ],
    [T, () => F],
  ])(ctype)
}

